export default "__VITE_ASSET__Dui7YTVH__"